/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { CreateTemplateInstanceCommandBarContainer as CreateTemplateInstanceCommandBar } from './CreateTemplateInstanceCommandBar.container';
